import { render, staticRenderFns } from "./SOVDetailed.vue?vue&type=template&id=d26728f2&scoped=true"
import script from "./SOVDetailed.vue?vue&type=script&lang=js"
export * from "./SOVDetailed.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailed.vue?vue&type=style&index=0&id=d26728f2&prod&lang=css"
import style1 from "./SOVDetailed.vue?vue&type=style&index=1&id=d26728f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26728f2",
  null
  
)

export default component.exports